import { useTranslation } from 'react-i18next';
import { SoldOut } from 'autogen/translation-keys/trans-website-shared-buttons';
import { Button, ButtonWithIcon } from 'components/Button';
import Icon from 'components/Icon';
import { eventCategoryToContext } from 'modules/tracking/GA4';
import { GA4Tracking } from 'modules/tracking/GA4/GA4Tracking';
import type { IProductAction, ProductActionProps } from '../../shared/types';

function track(trackingInfo: IProductAction['trackingInfo']) {
    GA4Tracking({
        eventName: 'sold_out',
        context: eventCategoryToContext(trackingInfo.eventCategory),
        category: 'ecommerce'
    });
}

export function SoldOutButton({ params, trackingInfo, children, ...restProps }: ProductActionProps['SoldOut']) {
    const { t } = useTranslation();

    // TODO nkr NavigationLink
    return (
        <Button
            as="a"
            href={params.productNavigationLink.url}
            variant="primary"
            onClick={() => track(trackingInfo)}
            {...restProps}
        >
            {children || t(SoldOut)}
        </Button>
    );
}

export function SoldOutButtonCompact({ params, trackingInfo, ...restProps }: ProductActionProps['SoldOut']) {
    const { t } = useTranslation();

    // TODO nkr NavigationLink
    return (
        <ButtonWithIcon
            as="a"
            href={params.productNavigationLink.url}
            variant="secondary"
            icon={<Icon type="ChevronRight" size={16} />}
            aria-label={t(SoldOut)}
            onClick={() => track(trackingInfo)}
            {...restProps}
        />
    );
}

export default Object.assign(SoldOutButton, {
    Compact: SoldOutButtonCompact
});
